import type { TOC } from '@ember/component/template-only';
import { and, eq, not } from 'ember-truth-helpers';

interface UiButtonGroupSignature {
  Args: {
    reverse?: boolean;
    segmented?: boolean;
    spacing?: 'tight' | 'even';
    vertical?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLDivElement;
}

export default <template>
  <div class="ui__button_group__wrapper" ...attributes>
    <div
      class="ui__button_group
        {{if @segmented 'ui__button_group--segmented'}}
        {{if (and (not @segmented) (eq @spacing 'tight') (not (eq @spacing 'even'))) 'ui__button_group--spacing-tight'}}
        {{if (and (not @segmented) (eq @spacing 'even') (not (eq @spacing 'tight'))) 'ui__button_group--spacing-even'}}
        {{if (and (not @segmented) (eq @vertical true)) 'ui__button_group--vertical'}}
        {{if (eq @reverse true) 'ui__button_group--reverse'}}
        "
    >
      {{yield}}
    </div>
  </div>
</template> satisfies TOC<UiButtonGroupSignature>;
